module.exports = __webpack_public_path__ + "img/pizzakurs_960px.8ce17e9b.jpg";